"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmaStakingService = exports.StakingValidatorStatus = void 0;
var staking_1 = require("./firmachain/staking");
var FirmaUtil_1 = require("./FirmaUtil");
var StakingValidatorStatus;
(function (StakingValidatorStatus) {
    StakingValidatorStatus["ALL"] = "";
    StakingValidatorStatus["BONDED"] = "BOND_STATUS_BONDED";
    StakingValidatorStatus["UNBONDED"] = "BOND_STATUS_UNBONDED";
    StakingValidatorStatus["UNBONDING"] = "BOND_STATUS_UNBONDING";
})(StakingValidatorStatus = exports.StakingValidatorStatus || (exports.StakingValidatorStatus = {}));
var FirmaStakingService = /** @class */ (function () {
    function FirmaStakingService(config) {
        this.config = config;
    }
    FirmaStakingService.prototype.getTxClient = function (wallet) {
        return new staking_1.StakingTxClient(wallet, this.config.rpcAddress);
    };
    FirmaStakingService.prototype.getGasEstimationDelegate = function (wallet, validatorAddres, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxDelegate(wallet, validatorAddres, amount, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_1 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getGasEstimationUndelegate = function (wallet, validatorAddres, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxUndelegate(wallet, validatorAddres, amount, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_2 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getGasEstimationRedelegate = function (wallet, validatorSrcAddress, validatorDstAddress, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxRedelegate(wallet, validatorSrcAddress, validatorDstAddress, amount, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_3 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_3);
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getSignedTxDelegate = function (wallet, validatorAddres, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txClient, address, sendAmount, message, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        txClient = new staking_1.StakingTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        sendAmount = { denom: this.config.denom, amount: FirmaUtil_1.FirmaUtil.getUFCTStringFromFCT(amount) };
                        message = staking_1.StakingTxClient.msgDelegate({
                            delegatorAddress: address,
                            validatorAddress: validatorAddres,
                            amount: sendAmount
                        });
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_4 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_4);
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getSignedTxUndelegate = function (wallet, validatorAddres, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txClient, address, sendAmount, message, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        txClient = new staking_1.StakingTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        sendAmount = { denom: this.config.denom, amount: FirmaUtil_1.FirmaUtil.getUFCTStringFromFCT(amount) };
                        message = staking_1.StakingTxClient.msgUndelegate({
                            delegatorAddress: address,
                            validatorAddress: validatorAddres,
                            amount: sendAmount
                        });
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_5 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_5);
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getSignedTxRedelegate = function (wallet, validatorSrcAddress, validatorDstAddress, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txClient, address, sendAmount, message, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        txClient = new staking_1.StakingTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        sendAmount = { denom: this.config.denom, amount: FirmaUtil_1.FirmaUtil.getUFCTStringFromFCT(amount) };
                        message = staking_1.StakingTxClient.msgRedelegate({
                            delegatorAddress: address,
                            validatorSrcAddress: validatorSrcAddress,
                            validatorDstAddress: validatorDstAddress,
                            amount: sendAmount
                        });
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_6 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_6);
                        throw error_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getSignedTxCreateValidator = function (wallet, validatorInfo, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txClient, message, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        txClient = new staking_1.StakingTxClient(wallet, this.config.rpcAddress);
                        message = staking_1.StakingTxClient.msgCreateValidator({
                            description: validatorInfo.description,
                            commission: validatorInfo.commission,
                            minSelfDelegation: validatorInfo.minSelfDelegation,
                            delegatorAddress: validatorInfo.delegatorAddress,
                            validatorAddress: validatorInfo.validatorAddress,
                            pubkey: validatorInfo.pubkey,
                            value: validatorInfo.value
                        });
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_7 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_7);
                        throw error_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getSignedTxEditValidator = function (wallet, validatorAddress, description, commissionRate, minSelfDelegation, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txClient, message, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        txClient = new staking_1.StakingTxClient(wallet, this.config.rpcAddress);
                        message = staking_1.StakingTxClient.msgEditValidator({
                            validatorAddress: validatorAddress,
                            description: description,
                            commissionRate: commissionRate,
                            minSelfDelegation: minSelfDelegation
                        });
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_8 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_8);
                        throw error_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.createValidator = function (wallet, validatorInfo, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, txClient, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxCreateValidator(wallet, validatorInfo, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        txClient = new staking_1.StakingTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_9 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_9);
                        throw error_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.editValidator = function (wallet, validatorAddress, description, commissionRate, minSelfDelegation, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, txClient, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxEditValidator(wallet, validatorAddress, description, commissionRate, minSelfDelegation, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        txClient = new staking_1.StakingTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_10 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_10);
                        throw error_10;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.redelegate = function (wallet, validatorSrcAddress, validatorDstAddress, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, txClient, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxRedelegate(wallet, validatorSrcAddress, validatorDstAddress, amount, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        txClient = new staking_1.StakingTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_11 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_11);
                        throw error_11;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.undelegate = function (wallet, targetAddress, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, txClient, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxUndelegate(wallet, targetAddress, amount, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        txClient = new staking_1.StakingTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_12 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_12);
                        throw error_12;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.delegate = function (wallet, targetAddress, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, txClient, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxDelegate(wallet, targetAddress, amount, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        txClient = new staking_1.StakingTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_13 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_13);
                        throw error_13;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // query
    FirmaStakingService.prototype.getUndelegationInfoFromValidator = function (address, validatorAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new staking_1.StakingQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.queryGetUndelegationInfoFromValidator(address, validatorAddress)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_14 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_14);
                        throw error_14;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getDelegationInfoFromValidator = function (address, validatorAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new staking_1.StakingQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.queryGetDelegationInfoFromValidator(address, validatorAddress)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_15 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_15);
                        throw error_15;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getTotalUndelegateInfo = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new staking_1.StakingQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.queryGetTotalUndelegateInfo(address)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_16 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_16);
                        throw error_16;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getTotalRedelegationInfo = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new staking_1.StakingQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.querygetTotalRedelegationInfo(address)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_17 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_17);
                        throw error_17;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getUndelegationListFromValidator = function (valoperAddress, paginationKey) {
        if (paginationKey === void 0) { paginationKey = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new staking_1.StakingQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.queryGetUndelegationListFromValidator(valoperAddress, paginationKey)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_18 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_18);
                        throw error_18;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getDelegationListFromValidator = function (valoperAddress, paginationKey) {
        if (paginationKey === void 0) { paginationKey = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_19;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new staking_1.StakingQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.queryGetDelegateListFromValidator(valoperAddress, paginationKey)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_19 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_19);
                        throw error_19;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getTotalDelegationInfo = function (address, paginationKey) {
        if (paginationKey === void 0) { paginationKey = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_20;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new staking_1.StakingQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.queryGetTotalDelegationInfo(address, paginationKey)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_20 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_20);
                        throw error_20;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getParams = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_21;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new staking_1.StakingQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.queryGetParams()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_21 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_21);
                        throw error_21;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getPool = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_22;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new staking_1.StakingQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.queryGetPool()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_22 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_22);
                        throw error_22;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getValidator = function (valoperAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_23;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new staking_1.StakingQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.queryValidator(valoperAddress)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_23 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_23);
                        throw error_23;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmaStakingService.prototype.getValidatorList = function (status, paginationKey) {
        if (status === void 0) { status = StakingValidatorStatus.ALL; }
        if (paginationKey === void 0) { paginationKey = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, result, error_24;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new staking_1.StakingQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.queryValidators(status.toString(), paginationKey)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        error_24 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_24);
                        throw error_24;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return FirmaStakingService;
}());
exports.FirmaStakingService = FirmaStakingService;
